import React from "react";
import {
  CustomDropDown,
  CustomForm,
  CustomInput,
  CustomTextArea,
} from "shared/AllInputs";
import CustomButton, {
  Buttonlayout,
  CustomButtonOutlined,
} from "shared/CustomButton";
import CustomCard from "shared/CustomCard";
import Page from "shared/Page";
import RentsetupContainer from "./RentsetupContainer";
import BaseRent from "../CommonComponents/BaseRent";
import MaintenanceCost from "../CommonComponents/MaintenanceCost";
import HeatingCost from "../CommonComponents/HeatingCost";
import AdministrativeCost from "../CommonComponents/AdministrativeCost";
import { Accordion, AccordionTab } from "primereact/accordion";

const RentsetupForms = ({ type }) => {
  const {
    data,
    baseRentData,
    maintenanceCostData,
    heatingData,
    administrativeCost,
    handleChange,
    onSubmit,
    loading,
    navigate,
    allRents,
    setAllRents,
    allMaintenaceCosts,
    setAllMaintenanceCosts,
    allHeatingCosts,
    setAllHeatingCosts,
    allHeatingDeductionCosts,
    setAllHeatingDeductionCosts,
    activeIndex,
    setActiveIndex
  } = RentsetupContainer();
  const accordianHeader = (heading) => {
    return (
      <div className="flex align-items-center justify-content-between w-full ">
        <p className="title w-4 text-base">{heading}</p>
      </div>
    );
  };

  return (
    <Page
      title={`${type} Rent Setup`}
      description={`Let’s ${type} your rent setup Details`}
      navigateLink={"/rent/list"}
    >
      <CustomCard>
        <CustomForm title="Rent Setup" extraClassName="text-xl">
          <CustomInput
            data={data}
            onChange={({ name, value }) =>
              handleChange({ name: name, value: value, form: "rent" })
            }
            name="regulationName"
            required
          />
          <CustomDropDown
            data={data}
            onChange={({ name, value }) =>
              handleChange({ name: name, value: value, form: "rent" })
            }
            name="federalState"
            options={[{ name: "Berlin", value: "berlin" }]}
            required
          />
          <CustomTextArea
            data={data}
            onChange={({ name, value }) =>
              handleChange({ name: name, value: value, form: "rent" })
            }
            name="note"
            required
            col={12}
            extraClassName="text-area-height"
          />
        </CustomForm>
        <CustomForm title="Tier Controller" extraClassName="text-xl">
          <Accordion multiple activeIndex={activeIndex} className="w-full mt-3" onTabChange={(e) => setActiveIndex(e.index)}>
            <AccordionTab
              tabIndex={0}
              className="mb-3"
              headerClassName="accordion-role-list"
              headerTemplate={() => accordianHeader("Base Rent")}
            >
              <BaseRent
                data={baseRentData}
                handleChange={handleChange}
                allValues={allRents}
                setAllValues={setAllRents}
              />
            </AccordionTab>
            <AccordionTab
              tabIndex={1}
              className="mb-3"
              headerClassName="accordion-role-list"
              headerTemplate={() => accordianHeader("Maintenance Cost")}
            >
              <MaintenanceCost
                data={maintenanceCostData}
                handleChange={handleChange}
                allValues={allMaintenaceCosts}
                setAllValues={setAllMaintenanceCosts}
                activeIndex={activeIndex}
              />
            </AccordionTab>
            <AccordionTab
              tabIndex={2}
              className="mb-3"
              headerClassName="accordion-role-list"
              headerTemplate={() => accordianHeader("Heating Cost")}
            >
              <HeatingCost
                data={heatingData}
                handleChange={handleChange}
                allHeatingCosts={allHeatingCosts}
                setAllHeatingCosts={setAllHeatingCosts}
                allHeatingDeductionCosts={allHeatingDeductionCosts}
                setAllHeatingDeductionCosts={setAllHeatingDeductionCosts}
                activeIndex={activeIndex}
              />
            </AccordionTab>
            <AccordionTab
              tabIndex={3}
              className="mb-3"
              headerClassName="accordion-role-list"
              headerTemplate={() => accordianHeader("Administrative Cost")}
            >
              <AdministrativeCost
                data={administrativeCost}
                handleChange={handleChange}
                activeIndex={activeIndex}
              />
            </AccordionTab>
          </Accordion>
        </CustomForm>
      </CustomCard>
      <Buttonlayout>
        <CustomButton
          onClick={onSubmit}
          label={type === "Edit" ? "Save Changes" : "Save"}
          loading={loading}
        />
        <CustomButtonOutlined
          label="Cancel"
          onClick={() => navigate(-1)}
        />
      </Buttonlayout>
    </Page>
  );
};

export default RentsetupForms;
